import { kebabCase } from 'lodash';

/**
 * The section of a project page's path (/project/<name>/edits/<id> -> 'edits'): '' on the
 * project's home page, undefined off a project page.
 */
export const projectSection = (pathname: string): string | undefined => {
  const match = /^\/project\/[^/]+(?:\/([^/]+))?/.exec(pathname);
  return match ? (match[1] ?? '') : undefined;
};

/**
 * Where to go when the user switches project in the header's project selector: the same section
 * of the new project (/project/<old>/edits/<id> -> /project/<new>/edits). IDs after the section
 * belong to the old project, so they're dropped. Off a project page, returns undefined - switching
 * project shouldn't take the user anywhere.
 */
export const pathForProjectSwitch = (pathname: string, projectName: string): string | undefined => {
  const section = projectSection(pathname);
  if (section === undefined) return undefined;

  return `/project/${kebabCase(projectName)}${section ? `/${section}` : ''}`;
};
